import React from 'react';
import PropTypes from 'prop-types';
import InputBlock from 'components/connectedForm/InputBlock';
import InputGroup from 'components/connectedForm/InputGroup';
import InputLabel from 'components/connectedForm/InputLabel';
import InputErrorMessage from 'components/connectedForm/InputErrorMessage';

import { Slider as FluentSlider } from '@fluentui/react/lib/Slider';

const Slider = ({
  active,
  id,
  label,
  includeLabel,
  flexBox,
  labelCols,
  inputCols,
  readOnly,
  hint,
  validationErrors,
  showWhenNotActive,
  touched,
  customValidationErrors,
  mandatory,
  value,
  defaultValue,
  min,
  snapToStep,
  max,
  step,
  tipFormatter,
  onChange,
  ...rest
}) => {
  const labelProps = {
    flexBox,
    id,
    includeLabel,
    hint,
    label,
    mandatory,
    readOnly,
  };

  return (
    <InputBlock flexBox={flexBox}>
      <InputLabel {...labelProps} cols={labelCols} />
      <InputGroup
        flexBox={flexBox}
        cols={includeLabel ? inputCols : 1}
        withLabel={includeLabel}
        data-testid={rest['data-testid']}
      >
        <FluentSlider
          min={min}
          max={max}
          step={step}
          value={parseInt(value ? value : defaultValue)}
          showValue
          snapToStep={snapToStep}
          valueFormat={tipFormatter}
          onChange={onChange}
        />
        <InputErrorMessage
          label={label}
          active={active}
          touched={touched}
          validationErrors={validationErrors}
          showWhenNotActive={showWhenNotActive}
          customValidationErrors={customValidationErrors}
        />
      </InputGroup>
    </InputBlock>
  );
};

Slider.propTypes = {
  active: PropTypes.bool,
  mandatory: PropTypes.bool,
  onChange: PropTypes.func,
  includeLabel: PropTypes.bool,
  readOnly: PropTypes.bool,
  flexBox: PropTypes.bool,
  labelCols: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  inputCols: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array, PropTypes.number]),
  validationErrors: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  label: PropTypes.string,
};
Slider.defaultProps = {
  active: false,
  mandatory: false,
  onChange: () => {},
  includeLabel: true,
  readOnly: false,
  flexBox: true,
  labelCols: 1 / 4,
  inputCols: 3 / 4,
  value: '',
  validationErrors: [],
  label: '',
};

export default Slider;
